var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 59,
    viewBox: "0 0 51 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.959 0.919434L50.959 9.66943V29.8194C50.959 40.1369 44.6265 47.3494 38.719 51.8269C35.1555 54.5056 31.2447 56.688 27.094 58.3144L26.8765 58.3969L26.814 58.4194L26.7965 58.4244L26.789 58.4269C26.7865 58.4269 26.784 58.4269 25.959 56.0694L25.1315 58.4294L25.1215 58.4244L25.104 58.4194L25.0415 58.3944L24.824 58.3144C23.6449 57.8585 22.4855 57.353 21.349 56.7994C18.4799 55.4057 15.7508 53.7406 13.199 51.8269C7.29398 47.3494 0.958984 40.1369 0.958984 29.8194V9.66943L25.959 0.919434ZM25.959 56.0694L25.1315 58.4294L25.959 58.7194L26.7865 58.4294L25.959 56.0694ZM25.959 53.3894L25.9815 53.3794C29.4406 51.9496 32.7056 50.0891 35.699 47.8419C41.044 43.7944 45.959 37.8769 45.959 29.8194V13.2194L25.959 6.21943L5.95898 13.2194V29.8194C5.95898 37.8769 10.874 43.7894 16.219 47.8444C19.219 50.0959 22.4916 51.959 25.959 53.3894ZM41.139 20.6769L23.4615 38.3544L12.854 27.7494L16.3915 24.2119L23.459 31.2844L37.6015 17.1419L41.139 20.6769Z",
    fill: "url(#paint0_linear_228_6697)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_228_6697",
    x1: 50.959,
    y1: 17.6567,
    x2: 12.8035,
    y2: 54.8526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335053"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.40a6b6a4c097d31e30590ffd726130cf.svg";
export { ForwardRef as ReactComponent };